import React, { FC } from 'react';
import dynamic from 'next/dynamic';

import { notEmpty } from '@crehana/utils';

import { VideoDialogProps } from '../../types';

const DynamicTrailerVideo = dynamic(
  () => import('@crehana/web/dist/components/CourseTrailerPlayer'),
  {
    ssr: false,
  },
);

const LazyTrailerVideo: FC<React.PropsWithChildren<VideoDialogProps>> = ({
  courseData,
}) => (
  <DynamicTrailerVideo
    title={courseData?.title}
    promoImage={courseData?.promoImage || undefined}
    imagePlaceholder={courseData?.imagePlaceholder || undefined}
    trailerSources={
      courseData?.trailerSource?.filter(notEmpty).map(el => ({
        isDefault: !!el.isDefault,
        videoUrl: el.videoUrl || '',
        videoSourceType: el.videoSourceType as string,
        imageUrl: el.imageUrl as string,
      })) || []
    }
    autoplay
  />
);

export default LazyTrailerVideo;
